<template>
  <div v-if="metadata">
    <product-metadata-item :value="currentMetaData.release" />
    <product-metadata-item
      :label="designerLabel"
      :value="currentMetaData.designer"
    />
    <product-metadata-item :label="sizeLabel" :value="currentMetaData.size" />
    <product-metadata-item :label="pagesLabel" :value="currentMetaData.pages" />
    <product-metadata-item
      :label="publicationLabel"
      :value="currentMetaData.publication"
    />
    <product-metadata-item
      :label="bindingLabel"
      :value="currentMetaData.binding"
    />
  </div>
</template>

<script>
import $ from 'jquery';
import ProductMetadataItem from './ProductMetadataItem.vue';

export default {
  name: 'ProductMetadata',
  components: {
    ProductMetadataItem
  },
  props: {
    designerLabel: {
      type: String,
      default: ''
    },
    sizeLabel: {
      type: String,
      default: ''
    },
    pagesLabel: {
      type: String,
      default: ''
    },
    publicationLabel: {
      type: String,
      default: ''
    },
    bindingLabel: {
      type: String,
      default: ''
    },
    metadata: {
      type: Object,
      default: () => {}
    },
    // eslint-disable-next-line vue/require-default-prop
    initialSelectedVariantId: {
      type: String
    }
  },
  data: function () {
    return {
      variantId: null
    };
  },
  computed: {
    currentVariantId() {
      if (this.variantId) {
        return this.variantId;
      }
      return this.initialSelectedVariantId;
    },
    currentMetaData() {
      if (
        this.metadata &&
        this.currentVariantId &&
        this.metadata[this.currentVariantId]
      ) {
        return this.metadata[this.currentVariantId];
      }
      return false;
    }
  },
  mounted() {
    $(document).on('pxlVariantChange', (event) => {
      const { data } = event.detail;
      let variantId = this.getVariantId(data);
      this.variantId = variantId;
    });
  },
  methods: {
    getVariantId(data) {
      return parseInt(data.variant.id);
    }
  }
};
</script>
